import { LANGS, useLang } from '../i18n.jsx';

/**
 * Conmutador de idioma. Es un grupo de botones y no un desplegable porque con
 * solo dos idiomas el cambio debe costar un clic, no dos.
 *
 * Cambiar de idioma NO reinicia la busqueda: los filtros viajan en clave
 * canonica inglesa, asi que el mismo conjunto de cartas se vuelve a pedir
 * traducido y el usuario se queda donde estaba.
 */
export default function LangSwitch() {
  const { lang, setLang, t } = useLang();

  return (
    <div className="langswitch" role="group" aria-label={t('language')}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          className={`langswitch__btn${l.code === lang ? ' is-active' : ''}`}
          aria-pressed={l.code === lang}
          title={l.label}
          onClick={() => setLang(l.code)}
        >
          {l.short}
        </button>
      ))}
    </div>
  );
}
